<script setup>
import SettingsLayout from "@/Layouts/Settings.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import Heading from "@/Components/Settings/Heading.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
//import { Inertia } from "@inertiajs/inertia";

const props = defineProps({
  errors: Object,
});

function submitForm() {
  form.post("/einstellungen/widget/bestellen");
}

const form = useForm({
  canusewidget: false,
});
</script>

<template>
  <SettingsLayout>
    <Head title="Widget - Grundeinstellungen" />

    <template #breadcrumb>Online-Terminvergabe</template>
    <template #controls>
      <HeaderLink href="/" type="close" class="mr-3">Schließen</HeaderLink>
    </template>

    <div class="flex flex-col h-full">
      <Heading title="Online-Terminvergabe bestellen" />

      <p class="max-w-2xl text-sm text-oteoText mb-8">
        Bieten Sie Ihren Patienten die Möglichkeit, ausgewählte Behandlungstypen
        und Behandler direkt über Ihre Praxis-Homepage zu buchen. Welche
        Behandlungstypen und Behandler online buchbar sind, bestimmen Sie selbst
        in den Grundeinstellungen. Sie können die Online-Terminvergabe als
        Widget einbinden oder als separate Seite nutzen.
      </p>

      <div class="grid-2 mb-10">
        <div>
          <label class="checkbox-container" for="canusewidget">
            <input
              required
              type="checkbox"
              id="canusewidget"
              name="canusewidget"
              value="true"
              v-model="form.canusewidget"
            />
            <strong>Ja, ich möchte die Online-Terminvergabe nutzen</strong>
            <p><span class="txt-blue">19,90 €</span> je Monat zzgl. MwSt.</p>
            <span class="checkmark"></span>
          </label>
        </div>

        <div class="mt-2 text-red-600 text-sm" v-if="errors.canusewidget">
          {{ errors.canusewidget }}
        </div>
      </div>

      <p class="max-w-2xl text-sm text-oteoText mb-8">
        Ich bin mit den
        <a
          target="_blank"
          class="underline"
          href="https://www.spitta.de/footer-2/agb.html"
          >AGB</a
        >, den
        <a
          target="_blank"
          class="underline"
          href="https://www.spitta.de/footer-2/datenschutz.html"
          >Datenschutzbestimmungen</a
        >
        und der
        <a
          target="_blank"
          class="underline"
          href="https://www.spitta.de/footer-2/auftragsverarbeitung.html"
          >Auftragsverarbeitung</a
        >
        einverstanden.
      </p>

      <div class="mb-8 relative">
        <button
          @click="submitForm()"
          class="px-20 py-3 text-xl font-semibold rounded-lg text-white bg-oteo-300 hover:opacity-70 cursor-pointer"
        >
          <span> Kostenpflichtig bestellen </span>
        </button>
      </div>
    </div>
  </SettingsLayout>
</template>

<style scoped>
.checkbox-container p {
  margin-top: 0;
}

.checkbox-container {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  line-height: 22px;
  font-size: 16px;
}

.checkbox-container .txt-blue {
  font-weight: 700;
}

.checkbox-container input {
  opacity: 0;
  position: absolute;
  cursor: pointer;
  width: 20px;
  left: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 2px;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
  top: 0;
  left: 0;
}

input:checked ~ .checkmark:after {
  display: block;
}

.checkmark:after {
  background: url("/storage/landing/icons8-done.svg");

  background-position: center;
  background-size: contain;
  width: 22px;
  border-color: #006eb4;
  height: 22px;
}

.checkbox-container:hover input ~ .checkmark {
  cursor: pointer;
}
.txt-blue {
  color: #006eb4;
}
</style>
